/* src/app/admin/user/user.component.scss */
.pageable-table {
  transition: transform 0.2s ease-out !important;
}
/*# sourceMappingURL=user.component-J5QAYMQD.css.map */
